import { Empty, Table } from 'antd';

import type { ModelCertificate } from '@app/api/Certificates';
import {
  ConfirmDeletingElement,
  EmptyComponentWithDataTestId,
  Error403Unauthorized,
} from '@app/components';
import { FiltersAccordion } from '@app/shared/components';

import { CertificateModal } from '../components/CertificateModal';
import { CertificatesFilters } from '../components/CertificatesFilters';
import { CERTIFICATES_TABLE_SCROLL_X } from '../data/constants';
import { useCertificates } from '../hooks/useCertificates';
import { useCertificatesEffects } from '../hooks/useCertificatesEffects';

import type { FC } from 'react';

import '../styles/Certificates.scss';

export const Certificates: FC = () => {
  const {
    certificates,
    columns,
    isLoading,
    pagination,
    page,
    clampedPage,
    setPage,
    isSearchApplied,
    isMobile,
    canView,
    unsavedSearchTerm,
    onChangeSearchTerm,
    onSearch,
    onReset,
    isModalOpen,
    editingCertificateId,
    openCreateModal,
    closeModal,
    setHeader,
    isDeleteModalOpen,
    deleteModalContent,
    isDeleting,
    setIsDeleteModalOpen,
    confirmDelete,
  } = useCertificates();

  useCertificatesEffects({
    setHeader,
    openCreateModal,
    page,
    clampedPage,
    setPage,
  });

  if (!canView) {
    return <Error403Unauthorized />;
  }

  return (
    <div className="Certificates">
      <FiltersAccordion>
        <CertificatesFilters
          searchTerm={unsavedSearchTerm}
          onChangeSearchTerm={onChangeSearchTerm}
          onSearch={onSearch}
          onReset={onReset}
        />
      </FiltersAccordion>
      <Table<ModelCertificate>
        className="Certificates__table"
        columns={columns}
        dataSource={certificates}
        rowKey="Id"
        loading={isLoading}
        size={isMobile ? 'small' : 'middle'}
        scroll={{ x: CERTIFICATES_TABLE_SCROLL_X }}
        pagination={pagination}
        locale={{
          emptyText: isSearchApplied ? (
            <Empty
              description={
                <span data-testid="no-data">Сертификаты не найдены</span>
              }
            />
          ) : (
            <EmptyComponentWithDataTestId />
          ),
        }}
      />
      <CertificateModal
        isOpen={isModalOpen}
        certificateId={editingCertificateId}
        onClose={closeModal}
      />
      <ConfirmDeletingElement
        modalOpen={isDeleteModalOpen}
        setModalOpen={setIsDeleteModalOpen}
        handleDelete={confirmDelete}
        content={deleteModalContent}
        title="Удаление сертификата"
        isStageDeletionLoading={isDeleting}
        modalDataTestId="delete-certificate-popup"
        titleDataTestId="delete-certificate-popup-title"
        descriptionDataTestId="delete-certificate-popup-description"
      />
    </div>
  );
};
